import React, { createContext, useContext, useRef, useState, useEffect } from 'react';

// Создаем контекст для хранения ссылок на элементы для скроллинга
const ScrollContext = createContext({});

// Провайдер контекста
export const ScrollProvider = ({ children }) => {
  // Создаем объект для хранения ссылок на различные элементы
  const refs = {
    requestForm: useRef(null),
    // Здесь можно добавить другие refs для будущих секций
    // services: useRef(null),
    // contacts: useRef(null),
  };
  
  // Добавляем состояние для хранения информации о подсвеченной секции
  const [highlightedSection, setHighlightedSection] = useState(null);
  // Флаг, указывающий, что скролл был инициирован программно
  const [targetSection, setTargetSection] = useState(null);
  // Отслеживаем, какие секции видимы в данный момент
  const [visibleSections, setVisibleSections] = useState({});

  // Настройка IntersectionObserver для отслеживания видимости секций
  useEffect(() => {
    const observers = {};
    
    // Создаем наблюдателей для каждой секции
    Object.entries(refs).forEach(([name, ref]) => {
      if (ref.current) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              console.log(`Секция ${name} ${entry.isIntersecting ? 'видима' : 'не видима'}, видимость: ${entry.intersectionRatio.toFixed(2)}`);
              
              // Обновляем состояние видимости
              setVisibleSections(prev => ({
                ...prev,
                [name]: entry.isIntersecting
              }));
              
              // Если секция полностью видима и это целевая секция для подсветки
              if (entry.isIntersecting && name === targetSection) {
                console.log(`Секция ${name} полностью видима, активируем подсветку`);
                setHighlightedSection(name);
                
                // Снимаем флаг целевой секции
                setTargetSection(null);
                
                // Автоматически снимаем подсветку через определенное время
                setTimeout(() => {
                  setHighlightedSection(null);
                  console.log(`Подсветка секции ${name} снята`);
                }, 250);
              }
            });
          },
          { threshold: 0.8 } // Активируем, когда 80% секции видимо
        );
        
        observer.observe(ref.current);
        observers[name] = observer;
      }
    });
    
    // Очищаем наблюдателей при размонтировании
    return () => {
      Object.values(observers).forEach(observer => observer.disconnect());
    };
  }, [refs, targetSection]); // Перезапускаем при изменении refs или targetSection

  // Функция для скроллинга к определенному элементу
  const scrollTo = (refName) => {
    console.log(`Прокрутка к секции: ${refName}`);
    const element = refs[refName]?.current;
    if (element) {
      // Устанавливаем целевую секцию для подсветки
      setTargetSection(refName);
      
      // Прокручиваем страницу к элементу с плавной анимацией
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      console.error(`Секция ${refName} не найдена`);
    }
  };

  return (
    <ScrollContext.Provider value={{ 
      refs, 
      scrollTo, 
      highlightedSection, 
      visibleSections 
    }}>
      {children}
    </ScrollContext.Provider>
  );
};

// Хук для использования контекста
export const useScroll = () => useContext(ScrollContext); 